import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-user-profile-menu',
    templateUrl: './user-profile-menu.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiUserProfileMenuComponent {

    @HostBinding() class = 'eui-user-profile-menu'; // eui-u-anim eui-u-anim--flipInY'';

    constructor() {
    }
}
